import React, { ReactElement, ReactNode } from 'react';
import { PropsWithChildren } from 'react';
import { Element } from 'react-scroll';
import { PanelWrapperStyle, PanelTitleStyle, PanelBodyStyle, PanelSectionStyle } from './style';

interface PanelProps {
  name?: string;
  title?: ReactNode;
}

const Panel = (props: PropsWithChildren<PanelProps>) => {
  const { name, title, children } = props;

  const isEmptyPanel = React.Children.toArray(children).every((child) => (child as ReactElement).props.hideIf);

  const panelElement = (
    <PanelWrapperStyle>
      {!!title && <PanelTitleStyle>{title}</PanelTitleStyle>}
      <PanelBodyStyle>{children}</PanelBodyStyle>
    </PanelWrapperStyle>
  );

  return isEmptyPanel ? null : name ? <Element name={name}>{panelElement}</Element> : panelElement;
};

interface PanelSectionProps {
  hideIf?: boolean;
}

Panel.Section = function Section(props: PropsWithChildren<PanelSectionProps>) {
  const { children, hideIf = false } = props;
  return hideIf ? null : <PanelSectionStyle>{children}</PanelSectionStyle>;
};

export default Panel;
